import { createFileRoute, useRouteContext } from "@tanstack/react-router";

import { CreateEventPage } from "./-components/create-event.page";

export const Route = createFileRoute("/_auth/org/$orgId/event/create/")({
  component: Page
});

function Page() {
  const { org } = useRouteContext({ from: "/_auth/org/$orgId/event/create/" });
  return <CreateEventPage org={org} />;
}
